import styled from "styled-components";

export const CustomInput = styled.input`
  width: 100%;

  margin: 7px 0;
  padding: 10px;

  border-radius: 5px;
`;
